import React from 'react';
import './DebugInfoForm.css';

/**
 * Debug info form component
 * Handles the form UI for fetching case debug information
 * Always visible with case status indicator
 */
const DebugInfoForm = ({
  // Form state
  formData,

  // Event handlers
  onChange,
  onSubmit,

  // Data
  groupName,
  fetchedCaseId,

  // State
  isSubmitting,
}) => {
  const env = process.env.REACT_APP_ENV;
  const hasLoadedCase = !!fetchedCaseId;
  const hasInput = !!formData.caId?.trim();
  const isViewingDifferentCase = hasLoadedCase && hasInput && formData.caId !== fetchedCaseId;

  return (
    <div className="debug-info-form">
      <form onSubmit={onSubmit} className="debug-info-form__form">
        {/* Input Row */}
        <div className="debug-info-form__input-row">
          <div className="debug-info-form__input-wrapper">
            <input
              type="text"
              placeholder="Enter Case ID (UUID)"
              name="caId"
              value={formData.caId}
              onChange={onChange}
              required
              className="debug-info-form__input"
              spellCheck="false"
              autoComplete="off"
            />
            {/* Status Indicator */}
            {hasLoadedCase && (
              <div className={`debug-info-form__status ${isViewingDifferentCase ? 'debug-info-form__status--stale' : ''}`}>
                <span className="debug-info-form__status-dot" />
                <span className="debug-info-form__status-text">
                  {isViewingDifferentCase ? 'viewing different' : 'loaded'}
                </span>
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="debug-info-form__btn"
          >
            {isSubmitting ? (
              <>
                <span className="debug-info-form__spinner" />
                Fetching...
              </>
            ) : (
              'Fetch'
            )}
          </button>
        </div>

        {/* Loaded Case Badge */}
        {hasLoadedCase && (
          <div className="debug-info-form__loaded-badge">
            <span className="debug-info-form__loaded-label">Viewing:</span>
            <code className="debug-info-form__loaded-id">{fetchedCaseId}</code>
            <span className="debug-info-form__loaded-env">{groupName} · {env}</span>
          </div>
        )}
      </form>
    </div>
  );
};

export default DebugInfoForm;
